import { Controller } from "stimulus";

export default class extends Controller
{
    static targets = ["message", "confirm", "cancel", "close"];

    LAST_ASSOCIATED_ELEMENT = null;

    connect()
    {
        window.addEventListener("show-dialog", e =>
        {
            this.element.classList.add("toast-invisible");

            let bin = e.detail;
            this.LAST_ASSOCIATED_ELEMENT = bin;
            let text = bin.dataset["text"];
            this.messageTarget.innerText = text;

            let binRect = bin.getBoundingClientRect();
            let dialogRect = this.element.getBoundingClientRect();
            
            let binCenter = { x: binRect.left + binRect.width/2, y: binRect.bottom - binRect.height/2 };
            
            let dialogPosition = {}

            if(binRect.bottom + dialogRect.height + 20 > window.innerHeight )
            {
                this.element.classList.remove("top", "left", "right");
                this.element.classList.add("bottom");
                dialogPosition = { x: binCenter.x - dialogRect.width/2, y: binCenter.y - 26 - dialogRect.height + window.scrollY };
            }
            else if( binRect.left - dialogRect.width/2 - 20 < 0)
            {
                this.element.classList.remove("bottom", "top", "right");
                this.element.classList.add("left");

                dialogPosition = { x: binCenter.x + 26, y: binCenter.y + window.scrollY - dialogRect.height / 2};
            }
            else if( binRect.right + dialogRect.width/2 + 20 > window.innerWidth)
            {
                this.element.classList.remove("bottom", "top", "left");
                this.element.classList.add("right");

                dialogPosition = { x: binCenter.x - 26 - dialogRect.width, y: binCenter.y + window.scrollY - dialogRect.height / 2};
            }
            else
            {
                this.element.classList.remove("bottom", "left", "right");
                this.element.classList.add("top");

                dialogPosition = { x: binCenter.x - dialogRect.width/2, y: binCenter.y + 24 + window.scrollY };
            }

            this.element.style.left = dialogPosition.x + "px";
            this.element.style.top = dialogPosition.y + "px";

            this.element.classList.remove("toast-invisible")
        });

        this.cancelTarget.addEventListener("click", e =>
        {
            this.close();
        })

        this.closeTarget.addEventListener("click", e =>
        {
            this.close();
        })

        document.addEventListener("click", e =>
        {
            if (e.target == this.element ||
                this.element.contains(e.target) ||
                e.target == this.LAST_ASSOCIATED_ELEMENT ||
                this.LAST_ASSOCIATED_ELEMENT?.contains(e.target)
            ) return;
            else this.close()
        })

        this.confirmTarget.addEventListener("click", e =>
        {
            let event = new CustomEvent("confirm-delete", { detail: true });
            this.LAST_ASSOCIATED_ELEMENT.dispatchEvent(event);

            this.element.classList.add("toast-invisible");
        })
    }

    close()
    {
        this.element.classList.add("toast-invisible");
    }
}